<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="dialogVisible"
    :close-on-click-modal="false"
    append-to-body
    title="选择生产中心"
    width="800px"
    top="8vh"
  >
    <TableSelect
      :filter="filter"
      ref="tableSelect"
      :columns="columns"
      module="basic"
      url="workCenters"
      @select="selectWorkCenter"
      @reset="resetHandle"
    >
      <template slot="adSearch">
        <el-form :inline="true" ref="form" :model="filter">
          <el-form-item label="编号" prop="workCenterNo">
            <el-input v-model.trim="filter.workCenterNo" placeholder="请输入工厂中心编号" clearable />
          </el-form-item>
          <el-form-item label="名称" prop="workCenterName">
            <el-input v-model.trim="filter.workCenterName" placeholder="请输入生产中心名称" clearable />
          </el-form-item>
        </el-form>
      </template>
    </TableSelect>
  </el-dialog>
</template>

<script>
import TableSelect from "@/components/TableSelect.vue";

export default {
  components: { TableSelect },
  data() {
    return {
      dialogVisible: false,
      filter: {
        workCenterNo: "",
        workCenterName: "",
      },
      columns: [
        {
          title: "编号",
          key: "workCenterNo",
          width: 110,
          align: "center",
        },
        {
          title: "名称",
          key: "workCenterName",
          minWidth: 150,
        },
        {
          title: "所属车间",
          key: "workshopName",
          minWidth: 150,
        },
        {
          title: "操作",
          slot: "action",
          width: 80,
          align: "center",
        },
      ],
    };
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.form.resetFields();
        this.$refs.tableSelect.loadData();
      });
    },

    selectWorkCenter(row) {
      this.dialogVisible = false;
      this.$emit("select", row);
    },

    // 重置
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },
  },
};
</script>
